import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserParameter } from '@dto/UserParameter';

@Injectable({
  providedIn: 'root'
})
export class UserParameterService {

  constructor(private http: HttpClient) { }

  apiServer = environment.apiHost + environment.apiPort;
  loadAll(subscriberCode: string, hotelId: number) {
    return this.http.get(this.apiServer + '/api/UserParameter/LoadAll/' + subscriberCode + "/" + hotelId);
  }

  loadByTypeCode(subscriberCode: string, hotelId: number, eMail: string, typeCode: string) {
    return this.http.get(this.apiServer + '/api/UserParameter/LoadByTypeCode/' + subscriberCode + "/" + hotelId + "/" + eMail + "/" + typeCode);
  }
  add(data: UserParameter) {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.post(this.apiServer + '/api/UserParameter/Add', data, { headers });
  }

  update(data: UserParameter) {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.post(this.apiServer + '/api/UserParameter/Update', data, { headers });
  }

  delete(id: number) {
    return this.http.delete(this.apiServer + '/api/UserParameter/Delete/' + id);
  }

  updateAll(data: UserParameter[]) {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.post(this.apiServer + '/api/UserParameter/UpdateAll', data, { headers });
  }

}
